import { HttpClient } from '@angular/common/http';
import { FactoryProvider, inject } from '@angular/core';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { DataApiService, NotificationService } from '@xpo-ltl/data-api';
import { JmeterApiService as JmeterSdk } from '@xpo-ltl/sdk-jmeter';

import { ConfigManagerProperties } from '../../shared/config-manager-properties.enum';

/** Preserve the SDK endpoint and SSO configuration; support an optional development URL override. */
export const JMETER_SDK_PROVIDER: FactoryProvider = {
  provide: JmeterSdk,
  useFactory: () => {
    const config = inject(ConfigManagerService);
    const override = config.getSetting<string>(ConfigManagerProperties.jmeterApiUrl)?.trim().replace(/\/+$/, '');
    let sdkConfig = config;
    if (override) {
      // Give only this SDK a different apiUrl. Auth and other SDKs keep the gateway configuration.
      sdkConfig = new Proxy(config, {
        get(target, property, receiver) {
          if (property === 'getSetting') {
            return (key: Parameters<ConfigManagerService['getSetting']>[0]) =>
              key === ConfigManagerProperties.apiUrl ? override : target.getSetting(key);
          }
          return Reflect.get(target, property, receiver);
        },
      });
    }
    const dataApi = new DataApiService(inject(HttpClient), inject(NotificationService), sdkConfig);
    const sdk = new JmeterSdk(dataApi);
    if (override) {
      sdk.switchApiContextRoot('');
    }
    return sdk;
  },
};
